<div *ngIf="isFromContract" class="mb-3">
  <p-messages severity="warn" [closable]="false">
    <ng-template pTemplate>
      <i class="pi pi-info-circle mr-2"></i>
      <span>Esta cola está gestionada automáticamente por el contrato asociado y no puede editarse desde aquí.</span>
    </ng-template>
  </p-messages>
</div>

<p-tabView>
  <p-tabPanel header="General">
    <form id="queueForm" [formGroup]="queueFormGroup" class="grid">
      <div class="input-field col-12 md:col-6">
        <label>Nombre *</label>
        <input pInputText formControlName="name" class="w-full" [readonly]="!isNew" />
      </div>
      <div class="input-field col-12 md:col-6">
        <label>Estrategia *</label>
        <p-dropdown [options]="strategies" formControlName="strategy" optionLabel="label" optionValue="value"
          appendTo="body"></p-dropdown>
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Timeout (s)</label>
        <input type="number" pInputText formControlName="timeout" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Retry (s)</label>
        <input type="number" pInputText formControlName="retry" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Wrap-up time (s)</label>
        <input type="number" pInputText formControlName="wrapuptime" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-6">
        <label>Música en espera</label>
        <input pInputText formControlName="musiconhold" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-6">
        <label>Tamaño máximo de cola (maxlen)</label>
        <input type="number" pInputText formControlName="maxlen" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Auto-pausa</label>
        <p-dropdown [options]="yesNoOptions" formControlName="autopause" optionLabel="label" optionValue="value"
          appendTo="body" showClear></p-dropdown>
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Ring in use</label>
        <p-dropdown [options]="yesNoOptions" formControlName="ringinuse" optionLabel="label" optionValue="value"
          appendTo="body" showClear></p-dropdown>
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Frecuencia anuncio (s)</label>
        <input type="number" pInputText formControlName="announceFrequency" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-8">
        <label>Anuncio periódico</label>
        <input pInputText formControlName="periodicAnnounce" class="w-full" />
      </div>
      <div class="input-field col-12 md:col-4">
        <label>Frecuencia anuncio periódico (s)</label>
        <input type="number" pInputText formControlName="periodicAnnounceFrequency" class="w-full" />
      </div>
    </form>
  </p-tabPanel>

  <p-tabPanel header="Miembros" [disabled]="isNew">
    <div class="flex justify-content-end mb-3">
      <p-button label="Añadir miembro" icon="pi pi-plus" (click)="addMember()" [disabled]="isFromContract"></p-button>
    </div>
    <p-table [value]="members" [scrollable]="true" scrollHeight="400px">
      <ng-template pTemplate="header">
        <tr>
          <th>Interface</th>
          <th>Nombre</th>
          <th width="100">Penalty</th>
          <th width="120">Pausado</th>
          <th width="80"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-member>
        <tr>
          <td>{{member.interface}}</td>
          <td>{{member.membername}}</td>
          <td>{{member.penalty}}</td>
          <td>
            <p-inputSwitch [ngModel]="!!member.paused" (onChange)="togglePause(member)" [disabled]="isFromContract"></p-inputSwitch>
          </td>
          <td>
            <p-button (click)="deleteMember(member)" [rounded]="true" [text]="false" severity="danger"
              pTooltip="Eliminar miembro" tooltipPosition="top" [disabled]="isFromContract">
              <i class="pi pi-trash"></i>
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">No hay miembros en esta cola</td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
</p-tabView>

<div class="flex justify-content-end gap-2 mt-4">
  <p-button label="Cancelar" severity="secondary" (click)="cancel()"></p-button>
  <p-button *ngIf="!isFromContract" label="Guardar" icon="pi pi-save" (click)="save()" [loading]="saving"></p-button>
</div>

<p-confirmDialog key="queueMemberConfirm" appendTo="body"></p-confirmDialog>
